import Page from "../../components/Page"
import ClaimRewardsForm from "../../forms/ClaimRewardsForm"

const ClaimRewards = () => {
  return (
    <Page>
      <ClaimRewardsForm />
    </Page>
  )
}

export default ClaimRewards
